import { faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Button from '@mui/material/Button'
import type { FC } from 'react'
import styled from 'styled-components'

import H6 from '@/components/H6'
import RadioInput from '@/components/RadioInput'
import type { IdentityProvider } from '@/types/Activity'
import { safelyOpenLink } from '@/utils/helpers'
import { identityProviderButtonMap } from '@/utils/identityProviderButtonMap'

export enum IdCheckSelectionEnum {
  PASS = 'Pass',
  FAIL = 'Fail',
  REFER = 'Refer',
}

export enum R2RSelectionEnum {
  PASS = 'Pass',
  FAIL = 'Fail',
}

const Container = styled.div`
  display: grid;
  gap: 30px;
`

const RadioContainer = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: row;
  margin-top: 10px;
`

const ExternalProvidersWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`

interface Props {
  hasR2RChecks: boolean
  hasIdentityChecks: boolean
  setIdCheckSelection: (selection: IdCheckSelectionEnum) => void
  setR2RCheckSelection: (selection: R2RSelectionEnum) => void
  idCheckSelection: IdCheckSelectionEnum | ''
  r2rCheckSelection: R2RSelectionEnum | ''
  identityProvider?: IdentityProvider
}

const IDVTVerify: FC<Props> = ({
  hasR2RChecks,
  hasIdentityChecks,
  setIdCheckSelection,
  setR2RCheckSelection,
  idCheckSelection,
  r2rCheckSelection,
  identityProvider,
}) => {
  const providerButton = identityProviderButtonMap(identityProvider)

  return (
    <Container>
      <ExternalProvidersWrapper>
        {providerButton && (
          <Button
            size="large"
            variant="text"
            startIcon={
              <FontAwesomeIcon
                icon={faUpRightFromSquare}
                size="sm"
                style={{ fontSize: '14px' }}
              />
            }
            onClick={() => {
              safelyOpenLink(providerButton.url)
            }}
            sx={{ whitespace: 'noWrap', textTransform: 'none' }}
          >
            {providerButton.label}
          </Button>
        )}
      </ExternalProvidersWrapper>
      <form>
        <H6>ID Check{!hasIdentityChecks && ' (Not applicable)'}</H6>
        <RadioContainer>
          <RadioInput
            name={'identity-check-pass'}
            checked={idCheckSelection === IdCheckSelectionEnum.PASS}
            onChange={() => {
              setIdCheckSelection(IdCheckSelectionEnum.PASS)
            }}
            value={idCheckSelection}
            disabled={!hasIdentityChecks}
          >
            {IdCheckSelectionEnum.PASS}
          </RadioInput>
          <RadioInput
            name={'identity-check-fail'}
            checked={idCheckSelection === IdCheckSelectionEnum.FAIL}
            onChange={() => {
              setIdCheckSelection(IdCheckSelectionEnum.FAIL)
            }}
            value={idCheckSelection}
            disabled={!hasIdentityChecks}
          >
            {IdCheckSelectionEnum.FAIL}
          </RadioInput>
          <RadioInput
            name={'identity-check-refer'}
            checked={idCheckSelection === IdCheckSelectionEnum.REFER}
            onChange={() => {
              setIdCheckSelection(IdCheckSelectionEnum.REFER)
            }}
            value={idCheckSelection}
            disabled={!hasIdentityChecks}
          >
            {IdCheckSelectionEnum.REFER}
          </RadioInput>
        </RadioContainer>
      </form>
      <form>
        <H6>R2R Check{!hasR2RChecks && ' (Not applicable)'}</H6>
        <RadioContainer>
          <RadioInput
            name={'r2r-check-pass'}
            checked={r2rCheckSelection === R2RSelectionEnum.PASS}
            onChange={() => {
              setR2RCheckSelection(R2RSelectionEnum.PASS)
            }}
            value={r2rCheckSelection}
            disabled={!hasR2RChecks}
          >
            {R2RSelectionEnum.PASS}
          </RadioInput>
          <RadioInput
            name={'r2r-check-fail'}
            checked={r2rCheckSelection === R2RSelectionEnum.FAIL}
            onChange={() => {
              setR2RCheckSelection(R2RSelectionEnum.FAIL)
            }}
            value={r2rCheckSelection}
            disabled={!hasR2RChecks}
          >
            Not validated
          </RadioInput>
        </RadioContainer>
      </form>
    </Container>
  )
}

export default IDVTVerify
